<template>
  <GmapMap
    :center="{ lat: this.mapData.latitude, lng: this.mapData.longitude }"
    :zoom="18"
    map-type-id="terrain"
    :options="{
      zoomControl: true,
      mapTypeControl: true,
      scaleControl: true,
      streetViewControl: true,
      rotateControl: true,
      fullscreenControl: true,
      disableDefaultUi: true,
    }"
    id="Gmaps"
  >
    <GmapMarker
      :position="this.mapData.position"
      :clickable="true"
      :draggable="false"
      content="aa"
      @click="show = !show"
    >
      <GmapInfoWindow :opened="show" @closeclick="show = false">{{
        this.mapData.address
      }}</GmapInfoWindow>
    </GmapMarker>
  </GmapMap>
</template>
<script>
export default {
  props: {
    mapData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      show: false,
    };
  },
};
</script>
<style scoped>
#Gmaps {
  width: 100%;
  height: 95%;
}
</style>
<style>
.vue-map-container .vue-map {
  border-radius: 5px !important;
}
</style>
